import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Heading,
  Image,
  HStack,
  VStack,
  IconButton,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const navigate = useNavigate();
  const asset = (p) => `${process.env.PUBLIC_URL}${p}`;
  return (
    <>
      <Box
        bgImage={`url(${asset('/bg_header.png')})`}
        bgSize="cover"
        bgPosition="center"
        h="200px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="fixed"
        top="0"
        left="0"
        right="0"
        zIndex="1000"
      >
        <VStack spacing={4}>
          <Flex align="center" justify="space-between">
            <HStack spacing={{ base: 2, md: 3 }}>
              <Image
                src={`${asset('/logo.png')}`}
                alt="Logo"
                boxSize={{ base: "30px", md: "50px" }}
              />
              <VStack spacing={2} align="flex-start">
              <Heading
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="normal"
                color="white"
                whiteSpace="nowrap"
              >
                สำนักเทคโนโลยีชีวภัณฑ์สัตว์
              </Heading>
              <Heading
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="normal"
                color="white"
                whiteSpace="nowrap"
              >
                Bureau of Veteinary Biologics
                </Heading>
              </VStack>
            </HStack>
          </Flex>
          <Box bg="white" w="full" h="1px" mt={2} />
          <Heading
            color="white"
            textAlign="center"
            fontSize={{ base: "2xl", md: "5xl"}}
            textShadow="2px 2px 4px rgba(0, 0, 0, 0.72)"
          >
            เงินทุนหมุนเวียนเพื่อผลิตวัคซีนจำหน่าย
          </Heading>
        </VStack>
      </Box>
    </>
  );
};

export default Header;
/*

        <Flex align="center" justify="space-between">
          <HStack spacing={{ base: 2, md: 3 }}>
            <Image
              src="/logo.png"
              alt="Logo"
              boxSize={{ base: "40px", md: "60px" }}
            />
            <Heading
              fontSize={{ base: "lg", md: "xl" }}
              fontWeight="bold"
              color="#005D6E"
              fontFamily="Inter, sans-serif"
              whiteSpace="nowrap"
            >
              สำนักเทคโนโลยีชีวภัณฑ์สัตว์
            </Heading>
          </HStack>

        </Flex>
*/
